import React, {Component} from 'react';
import {connect} from 'react-redux';
import { FormControl, InputGroup } from 'react-bootstrap';

class PasswordInput extends Component {

	render() {
		return (
			<InputGroup>
				<label className="sign-in-label">{this.props.label}</label>
		 		<FormControl className="sign-in-field" type="password" placeholder={this.props.placeholder} ref={this.props.ref} onChange={(e) => this.props.onChange(e.target.value)} />
	        </InputGroup>
		);
	}
}

PasswordInput = connect()(PasswordInput);

export default PasswordInput;


// WEBPACK FOOTER //
// ./src/components/common/PasswordInput.jsx